<template>
  <div class="relative w-screen">
    <img :src="thumbnailUrl" alt="" class="block h-auto w-screen" />
    <!--Transparent to white overlay-->
    <div
      class="pointer-events-none absolute bottom-0 left-0 h-8 w-screen bg-gradient-to-b from-transparent"
      :class="!isLightMode ? 'to-[#3c3a36]' : 'to-[#F6F4F0]'"
    ></div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'EventPageThumbnail',
  props: {
    thumbnailUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('eventPage', ['isLightMode']),
  },
};
</script>
